import { SerializedInventoryLocationBuilding } from '@enmon/commons/lib/tools';
import { ColumnFilterItem } from 'antd/lib/table/interface';
import { commodityTranslated } from 'components/Form/meter_details/constants';
import { IntlShape } from 'react-intl';
import { getPrioritizedCommodity } from '../../../components/Select/utils/getPrioritizedCommodities';

export const getCommodityFilters = (intl: IntlShape): ColumnFilterItem[] => {
  const prioritizedCommodities = getPrioritizedCommodity();

  return prioritizedCommodities.map(type => ({
    text: intl.formatMessage(commodityTranslated[type]),
    value: type,
  }));
};

export const getLocationBuildingFilters = (
  locationBuildings: SerializedInventoryLocationBuilding[],
): ColumnFilterItem[] => {
  const uniqueBuildings = Array.from(new Map(locationBuildings.map(building => [building.id, building])).values());
  return uniqueBuildings.map(({ name, id }) => ({ text: name, value: id }));
};
